var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 12,
    viewBox: "0 0 18 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 10.35C5.7636 10.35 3.036 8.6964 1.3152 6.15C3.036 3.6036 5.7636 1.95 9 1.95C12.2364 1.95 14.964 3.6036 16.6848 6.15C14.964 8.6964 12.2364 10.35 9 10.35ZM9 0.75C5.1696 0.75 1.9872 2.7972 0.0912014 5.832C0.0316018 5.92736 0 6.03755 0 6.15C0 6.26245 0.0316018 6.37264 0.0912014 6.468C1.9872 9.5028 5.1696 11.55 9 11.55C12.8304 11.55 16.0128 9.5028 17.9088 6.468C17.9684 6.37264 18 6.26245 18 6.15C18 6.03755 17.9684 5.92736 17.9088 5.832C16.0128 2.7972 12.8304 0.75 9 0.75ZM9 8.55C9.63652 8.55 10.247 8.29714 10.6971 7.84705C11.1471 7.39697 11.4 6.78652 11.4 6.15C11.4 5.51348 11.1471 4.90303 10.6971 4.45294C10.247 4.00286 9.63652 3.75 9 3.75C8.36348 3.75 7.75303 4.00286 7.30294 4.45294C6.85286 4.90303 6.6 5.51348 6.6 6.15C6.6 6.78652 6.85286 7.39697 7.30294 7.84705C7.75303 8.29714 8.36348 8.55 9 8.55Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.55f0d3153df6e91d0f3856ae67ac05ff.svg";
export { ForwardRef as ReactComponent };